import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button, Col, Row } from 'antd';
import Box from 'ui-box';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

function MobilePregnantNavBtn({
  isLast,
  prevRoutePath,
  nextRoutePath,
  fieldName
}) {
  const { t } = useTranslation();
  const history = useHistory();

  const { values, submitForm } = useFormikContext();
  const value = values[fieldName];

  const onPrev = () => {
    history.push(prevRoutePath);
  };

  const onNext = () => {
    if (isLast) {
      submitForm();
    } else {
      history.push(nextRoutePath);
    }
  };

  let isDisabled = true;
   if (Array.isArray(value)) {
    isDisabled = value.length;
  } else if (typeof value === 'string') {
    isDisabled = value;
  } else if (typeof value === 'number') {
    isDisabled = value >= 0;
  } else if (typeof value === 'boolean') {
    isDisabled = true
  }

  return (
    <>
      <Box height="100px" marginBottom="50px" />
        <Box
          position="absolute"
          bottom="50px"
          marginLeft="auto"
          marginRight="auto"
          left="0"
          right="0"
          width="100%"
          maxWidth="480px"
          paddingX={20}
        >
        <Row gutter={16} justify="space-between">
          <Col xs={12}>
            <Button
              htmlType="button"
              type="primary"
              size="large"
              onClick={onPrev}
              block
              ghost
            >
              <ArrowLeftOutlined style={{ color: '#15A9E1', marginRight: 10 }} /> {t(`common:button.previous`)}
            </Button>
          </Col>
          <Col xs={12}>
            <Button
              htmlType="button"
              type="primary"
              size="large"
              onClick={onNext}
              block
              disabled={!isDisabled}
            >
              {t(`common:button.next`)} <ArrowRightOutlined style={{ color: '#FFFFFF', marginLeft: 10 }} />
            </Button>
          </Col>
        </Row>
      </Box>
    </>
  );
}

MobilePregnantNavBtn.defaultProps = {
  isLast: false
};

const { string, bool } = PropTypes;

MobilePregnantNavBtn.propTypes = {
  isLast: bool,
  prevRoutePath: string.isRequired,
  nextRoutePath: string.isRequired
};

export default MobilePregnantNavBtn;
